module.exports = __webpack_public_path__ + "img/rsi-logo.05c110d7.png";